type UserStatusAction = 'deactivate' | 'restore';

type ConfirmDialogContent = {
  title: string;
  describe: (userName: string) => string;
  confirmLabel: string;
};

type UserDetailsTab = { id: string; label: string; value: string; disabled?: boolean };

export const USER_DETAILS_CONFIRM_DIALOG_CONTENT: Record<UserStatusAction, ConfirmDialogContent> = {
  deactivate: {
    title: 'Désactiver le client',
    describe: (userName) =>
      `Le client « ${userName} » ne pourra plus se connecter ni commander. Vous pourrez le réactiver.`,
    confirmLabel: 'Désactiver',
  },
  restore: {
    title: 'Réactiver le client',
    describe: (userName) => `Le client « ${userName} » pourra de nouveau se connecter et commander.`,
    confirmLabel: 'Réactiver',
  },
};

const ECO_USER_DETAILS_TABS: UserDetailsTab[] = [
  { id: 'invitations', label: 'Invitations', value: 'invitations' },
  { id: 'contacts', label: 'Contacts', value: 'contacts' },
];

export const getUserDetailsTabs = (isEco: boolean): UserDetailsTab[] => [
  { id: 'statistics', label: 'Statistiques', value: 'statistics', disabled: true },
  { id: 'informations', label: 'Informations', value: 'informations' },
  { id: 'orders', label: 'Commandes', value: 'orders' },
  ...(isEco ? ECO_USER_DETAILS_TABS : []),
  { id: 'discounts', label: 'Réductions', value: 'discounts' },
];

const DEFAULT_USER_DETAILS_TAB = 'informations';

export const resolveUserDetailsTab = (requestedTab: string | null, isEco: boolean): string =>
  getUserDetailsTabs(isEco).find((tab) => tab.id === requestedTab && !tab.disabled)?.id ?? DEFAULT_USER_DETAILS_TAB;
